import { Form, Validators, field } from "fw-model";

const { required } = Validators;

export class AtsLoginForm extends Form {
    @field("organizationId", required)
    public organizationId: string = null;
    @field("organizationUserId")
    public impersonationOrganizationUserId: string = null;
}
